import { useTranslation } from "react-i18next";
import { Icon, Menu, MenuItem } from "semantic-ui-react";

import "modules/PendingChecklistsDashboard/components/PinChecklistsTabs/PinChecklistsTabs.scss";

export enum PIN_CHECKLISTS_TABS {
  PinChecklists = "PinChecklists",
  ServiceChecklists = "ServiceChecklists",
  InterventionsChecklists = "InterventionsChecklists"
}

type PinChecklistsTabsProps = {
  activeTab: PIN_CHECKLISTS_TABS;
  toggleActiveTab: (tab: PIN_CHECKLISTS_TABS) => void;
};

export const PinChecklistsTabs = ({ activeTab, toggleActiveTab }: PinChecklistsTabsProps) => {
  const { t } = useTranslation();

  return (
    <div className="PinChecklistsTabs">
      <Menu attached="top" tabular>
        <MenuItem active={activeTab === PIN_CHECKLISTS_TABS.PinChecklists} onClick={() => toggleActiveTab(PIN_CHECKLISTS_TABS.PinChecklists)}>
          <div className="tab">
            <Icon name="pin" className={activeTab === PIN_CHECKLISTS_TABS.PinChecklists ? "active-tab" : "inactive-tab"} />
            <p className={`tab-item ${activeTab === PIN_CHECKLISTS_TABS.PinChecklists ? "active-tab" : "inactive-tab"}`}>{t("v8_pin_checklists", "Pin Checklists")}</p>
          </div>
        </MenuItem>

        <MenuItem
          name={PIN_CHECKLISTS_TABS.ServiceChecklists}
          active={activeTab === PIN_CHECKLISTS_TABS.ServiceChecklists}
          onClick={() => toggleActiveTab(PIN_CHECKLISTS_TABS.ServiceChecklists)}
        >
          <div className="tab">
            <Icon name="list" className={activeTab === PIN_CHECKLISTS_TABS.ServiceChecklists ? "active-tab" : "inactive-tab"} />
            <p className={activeTab === PIN_CHECKLISTS_TABS.ServiceChecklists ? "active-tab" : "inactive-tab"}> {t("v8_service_checklists", "Service Checklists")} </p>
          </div>
        </MenuItem>

        <MenuItem
          name={PIN_CHECKLISTS_TABS.InterventionsChecklists}
          active={activeTab === PIN_CHECKLISTS_TABS.InterventionsChecklists}
          onClick={() => toggleActiveTab(PIN_CHECKLISTS_TABS.InterventionsChecklists)}
        >
          <div className="tab">
            <Icon className={`screwdriver wrench ${activeTab === PIN_CHECKLISTS_TABS.InterventionsChecklists ? "active-tab" : "inactive-tab"}}`} />
            <p className={activeTab === PIN_CHECKLISTS_TABS.InterventionsChecklists ? "active-tab" : "inactive-tab"}>
              {t("v8_interventions_checklists", "Interventions Checklists")}
            </p>
          </div>
        </MenuItem>
      </Menu>
    </div>
  );
};
